import React, { useEffect, useMemo } from "react";
import {
  ALL_ASSISTANT_LLM_PROVIDER,
  ALL_TRANSCRIBER_PROVIDERS,
  ALL_VOICE_PROVIDERS,
  backgroundSound,
} from "../../../Common/Constants";
import TooltipSlider from "../../../Common/TooltipSlider";

const VoiceTab = ({
  isTabSelected,
  selectedBot,
  userPlanFeatures,
  formData,
  formError,
  handleChange,
  setFormData,
}) => {
  const assistantModelList = useMemo(() => {
    const allModelList = ALL_ASSISTANT_LLM_PROVIDER.find(
      (i) => i?.value === formData?.assistantProvider
    );
    return allModelList?.models || [];
  }, [formData?.assistantProvider]);

  const currentTranscriberData = useMemo(() => {
    const currentTranscriber = ALL_TRANSCRIBER_PROVIDERS.find(
      (i) => i?.value === formData?.transcriberProvider
    );
    return currentTranscriber;
  }, [formData?.transcriberProvider]);

  const currentLanguageData = useMemo(() => {
    const currentTranscriber = ALL_TRANSCRIBER_PROVIDERS.find(
      (i) => i?.value === formData?.transcriberProvider
    );
    if (formData?.transcriberModel) {
      const currentModel = currentTranscriber?.models?.find(
        (model) => model?.value === formData?.transcriberModel
      );
      if (currentModel?.languages && Array.isArray(currentModel?.languages)) {
        return currentModel?.languages;
      }
    }
    return currentTranscriber?.languages;
  }, [formData?.transcriberProvider, formData?.transcriberModel]);

  const currentVoiceProviderData = useMemo(() => {
    const currentTranscriber = ALL_VOICE_PROVIDERS.find(
      (i) => i?.value === formData?.provider
    );
    return currentTranscriber;
  }, [formData?.provider]);

  useEffect(() => {
    if (currentVoiceProviderData) {
      if (!currentVoiceProviderData?.isSpeed) {
        setFormData((prevData) => ({
          ...prevData,
          voice: {
            ...prevData?.voice,
            speed: undefined,
          },
        }));
      } else {
        setFormData((prevData) => ({
          ...prevData,
          voice: {
            ...prevData?.voice,
            speed: 1,
          },
        }));
      }
    }
  }, [currentVoiceProviderData]);

  return (
    <div
      className={
        isTabSelected
          ? "tabsContent__content tabsContent__content--selected"
          : "tabsContent__content"
      }
    >
      <div className="assistantAdvancedList">
        <div className="assistantAdvancedList__row">
          <div className="formRow formRow__2">
            <div className="formCol">
              <div className="form__Field">
                <label for="assistantProvider" className="form__label">
                  Assistant Model Provider
                </label>
                <select
                  className="form__select form__select--sm"
                  id="assistantProvider"
                  name="assistantProvider"
                  onChange={handleChange}
                  value={formData.assistantProvider}
                >
                  <option value="" selected disabled>
                    -Select-
                  </option>
                  {ALL_ASSISTANT_LLM_PROVIDER.map((prov) => (
                    <option value={prov.value}>{prov.label}</option>
                  ))}
                </select>
              </div>
            </div>
            {assistantModelList && assistantModelList?.length ? (
              <div className="formCol">
                <div className="form__Field">
                  <label for="assistantModel" className="form__label">
                    Assistant Model
                  </label>
                  <select
                    className="form__select form__select--sm"
                    id="assistantModel"
                    name="assistantModel"
                    onChange={handleChange}
                    value={formData?.assistantModel}
                  >
                    <option value="" selected disabled>
                      -Select-
                    </option>
                    {assistantModelList
                      ? assistantModelList.map((provider) => (
                          <option value={provider?.value}>
                            {provider?.label}
                          </option>
                        ))
                      : ""}
                  </select>
                </div>
              </div>
            ) : null}
          </div>
          <div className="formRow formRow__2">
            <div className="formCol">
              <div className="form__Field">
                <label for="transcriberProvider" className="form__label">
                  Transcriber Provider
                </label>
                <select
                  className="form__select form__select--sm"
                  id="transcriberProvider"
                  name="transcriberProvider"
                  onChange={handleChange}
                  value={formData.transcriberProvider}
                >
                  <option value="" selected disabled>
                    -Select-
                  </option>
                  {ALL_TRANSCRIBER_PROVIDERS.map((prov) => (
                    <option value={prov.value}>{prov.label}</option>
                  ))}
                </select>
              </div>
            </div>
            {currentTranscriberData &&
            currentTranscriberData?.models?.length ? (
              <div className="formCol">
                <div className="form__Field">
                  <label for="transcriberModel" className="form__label">
                    Transcriber Model
                  </label>
                  <select
                    className="form__select form__select--sm"
                    id="transcriberModel"
                    name="transcriberModel"
                    onChange={handleChange}
                    value={formData?.transcriberModel}
                  >
                    <option value="" selected disabled>
                      -Select-
                    </option>
                    {currentTranscriberData?.models
                      ? currentTranscriberData?.models.map((model) => (
                          <option value={model?.value}>{model?.label}</option>
                        ))
                      : ""}
                  </select>
                </div>
              </div>
            ) : null}
          </div>
          <div className="formRow formRow__2">
            <div className="formCol">
              <div className="form__Field">
                <label for="provider" className="form__label">
                  Voice Provider
                </label>
                <select
                  className="form__select form__select--sm"
                  id="provider"
                  name="provider"
                  onChange={handleChange}
                  value={formData.provider}
                >
                  <option value="" selected disabled>
                    -Select-
                  </option>
                  {ALL_VOICE_PROVIDERS
                    ? ALL_VOICE_PROVIDERS.map((prov) => (
                        <option value={prov.value}>{prov.label}</option>
                      ))
                    : ""}
                </select>
              </div>
              {formData?.provider != "openai" && (userPlanFeatures?.CUSTOM_VOICES || formData?.isCustomVoiceId) ? (
                <p className="para">
                  <div className="form__checkbox__option m_0">
                    <input
                      type="checkbox"
                      id="isCustomVoiceId"
                      className="form__checkbox__input"
                      value={formData?.isCustomVoiceId}
                      name="isCustomVoiceId"
                      checked={formData?.isCustomVoiceId ?? false}
                      onChange={handleChange}
                    />
                    <label
                      for="isCustomVoiceId"
                      className="form__checkbox__label"
                    >
                      Add Voice ID Manually
                    </label>
                  </div>
                </p>
              ) : null}
            </div>
            <div className="formCol">
              <div className="form__Field">
                <label for="voice" className="form__label">
                  {formData?.isCustomVoiceId ? "Custom Voice ID" : "Voice"}
                </label>
                {formData?.isCustomVoiceId ? (
                  <input
                    type="text"
                    id="voice"
                    maxLength={120}
                    className="form__input form__input--sm"
                    name="voice"
                    onChange={handleChange}
                    value={formData.voice}
                    autoComplete="off"
                    placeholder="voice"
                  />
                ) : (
                  <select
                    className="form__select form__select--sm"
                    id="voice"
                    name="voice"
                    onChange={handleChange}
                    value={formData.voice}
                  >
                    <option value="" selected disabled>
                      -Select-
                    </option>
                    {currentVoiceProviderData &&
                    currentVoiceProviderData?.voiceId
                      ? currentVoiceProviderData?.voiceId.map((voice) => (
                          <option value={voice?.value}>{voice?.label}</option>
                        ))
                      : ""}
                  </select>
                )}
              </div>
            </div>
          </div>
          <div className="formRow formRow__2">
            <div className="formCol">
              <div className="form__Field">
                <label for="backgroundSound" className="form__label">
                  Background Sound
                </label>
                <select
                  className="form__select form__select--sm"
                  id="backgroundSound"
                  name="backgroundSound"
                  onChange={handleChange}
                  value={formData.backgroundSound}
                >
                  <option value="" selected disabled>
                    -Select-
                  </option>
                  {backgroundSound
                    ? backgroundSound.map((sound) => (
                        <option value={sound}>{sound}</option>
                      ))
                    : ""}
                </select>
              </div>
            </div>
            <div className="formCol">
              <div className="form__Field">
                <label for="language" className="form__label">
                  Language
                </label>
                <select
                  className="form__select form__select--sm"
                  id="language"
                  name="language"
                  onChange={handleChange}
                  value={formData.language}
                >
                  <option value="" selected disabled>
                    -Select-
                  </option>
                  {currentLanguageData ? (
                    currentLanguageData.map((lang) => (
                      <option value={lang}>{lang}</option>
                    ))
                  ) : (
                    <option value={"en"}>en</option>
                  )}
                </select>
              </div>
            </div>
          </div>
          {formData?.speed ? (
            <div className="formRow formRow__2">
              <div className="formCol">
                <div className="form__Field form__Field--range">
                  <label for="claritySimilarity" className="form__label">
                    Speed
                  </label>
                  <div className="form__rangeSlider">
                    <div className="form__rangeSlider__info">
                      <div className="form__rangeSlider__flex">
                        <p className="para">Slow</p>
                        <TooltipSlider
                          name="speed"
                          value={formData?.speed}
                          min="0.5"
                          max="2"
                          step="0.1"
                          onChange={handleChange}
                        />
                        <p className="para">Fast</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
          <div className="formRow">
            <div className="formCol">
              <div className="form__checkboxSubField">
                <div className="form__checkbox">
                  <div className="form__checkbox__option m_0">
                    <input
                      type="checkbox"
                      className="form__checkbox__input"
                      id="emotionRecognitionEnabled"
                      name="emotionRecognitionEnabled"
                      checked={formData?.emotionRecognitionEnabled}
                      onChange={handleChange}
                    />
                    <label
                      for="AddVoiceIDManually"
                      className="form__checkbox__label"
                    >
                      Emotion Recognition
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="formRow">
            <div className="formCol">
              <div className="form__Field">
                <label for="endCallPhrases" className="form__label">
                  End Call Phrases
                </label>
                <input
                  type="text"
                  id="endCallPhrases"
                  maxLength={120}
                  className="form__input form__input--sm"
                  name="endCallPhrases"
                  onChange={handleChange}
                  value={formData.endCallPhrases}
                  autoComplete="off"
                  placeholder="End Call Phrases"
                />
              </div>
            </div>
            {formError?.endCallPhrasesError && (
              <div className="form__error">{formError.endCallPhrasesError}</div>
            )}
          </div>
          <div className="formRow">
            <div className="formCol">
              <div className="form__Field">
                <label for="voiceMailMessage" className="form__label">
                  Voicemail Message
                </label>
                <input
                  type="text"
                  id="voiceMailMessage"
                  maxLength={120}
                  className="form__input form__input--sm form__input--disabled"
                  name="voiceMailMessage"
                  disabled
                  onChange={handleChange}
                  value={formData.voiceMailMessage}
                  autoComplete="off"
                  placeholder="Voicemail Message"
                />
              </div>
            </div>
            {formError?.voiceMailMessageError && (
              <div className="form__error">
                {formError.voiceMailMessageError}
              </div>
            )}
          </div>
          <div className="formRow">
            <div className="formCol">
              <div className="form__Field">
                <label for="endCallMessage" className="form__label">
                  End Call Message
                </label>
                <input
                  type="text"
                  id="endCallMessage"
                  maxLength={120}
                  className="form__input form__input--sm form__input--disabled"
                  name="endCallMessage"
                  onChange={handleChange}
                  disabled
                  value={formData.endCallMessage}
                  autoComplete="off"
                  placeholder="End Call Message"
                />
              </div>
            </div>
            {formError?.endCallMessageError && (
              <div className="form__error">{formError.endCallMessageError}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VoiceTab;
